export default {
  adguard: {
    title: 'AdGuard AdBlocker',
    steps: [
      {
        text: 'Click the ‘AdGuard’ on the toolbar.',
        image: '/img/ad/adguard-0.png',
      },
      {
        text:
          'Go To Settings page. Inside ‘Settings’ page choose ‘Filters’ menu item on the left side And switch ‘Ad blocking’ off in order to show Ads.',
        image: '/img/ad/adguard-1.png',
      },
      {
        text: 'Go to ‘User rules’ tab and add these 4 rules to list',
        image: '/img/ad/adguard-2.png',
        snippet: `
          @@||fairview-ads.com
          @@||cdn.fairview-ads.com/js/clickTag.min.js
          @@||cdn.fairview-ads.com/js/creatives
          @@||s0.2mdn.net/ads/studio/Enabler.js
        `,
      },
      {
        text: 'Go to any tab with fairView opened sidebar and reload the page.',
      },
    ],
  },
  ublockOrigin: {
    title: 'uBlock Origin',
    steps: [
      {
        text: 'Click on the uBlock Origin extension’s icon.',
      },
      {
        text: 'Click the Settings icon.',
        image: '/img/ad/ublock-origin-0.png',
      },
      {
        text:
          'After visiting the Settings page go to ‘Filter lists’ tab and disable everything inside Ads block',
        image: '/img/ad/ublock-origin-1.png',
      },
      {
        text:
          'Next go to the ‘My Filters’ tab and add required filters to the list. After adding filters click ‘Apply Changes’ button. ',
        image: '/img/ad/ublock-origin-2.png',
        snippet: `
          @@||fairview-ads.com
          @@||cdn.fairview-ads.com/js/clickTag.min.js
          @@||cdn.fairview-ads.com/js/creatives
          @@||s0.2mdn.net/ads/studio/Enabler.js
        `,
      },
      {
        text: 'Close Settings page. Go to any webpage and reload it.',
      },
    ],
  },
  adblockPlus: {
    title: 'AdBlock Plus',
    steps: [
      {
        text:
          'Click AdBlock icon -> Inside opened popup window please click to ‘Gear’ in order to open the AdBlock Options Page.',
        image: '/img/ad/adblock-plus-0.png',
      },
      {
        text: 'Inside Options Page add disable EazyList filter list (see Screenshot below)',
        image: '/img/ad/adblock-plus-1.png',
        snippet: `
          @@||fairview-ads.com
          @@||cdn.fairview-ads.com/js/clickTag.min.js
          @@||cdn.fairview-ads.com/js/creatives
          @@||s0.2mdn.net/ads/studio/Enabler.js
        `,
      },
      {
        text: 'Reload webpage where you want see the FairView ads',
      },
    ],
  },
  ublock: {
    title: 'uBlock',
    steps: [
      {
        text: 'Click ‘uBlock’ icon on the toolbar',
      },
      {
        text: 'Go to ‘Settings’ page',
        image: '/img/ad/ublock-0.png',
      },
      {
        text: 'Open ‘3rd-party filters’ tab and disable ‘EasyList’ checkbox.',
      },
      {
        text:
          'Enable ‘EasyList without element hiding rules’ checkbox to true value. Click ‘Update now’ to apply changes.',
        image: '/img/ad/ublock-1.png',
      },
      {
        text:
          'Go to ‘My filters’ tab and add filters to the list and click ‘Apply changes’ button.',
        image: '/img/ad/ublock-2.png',
        snippet: `
          @@||fairview-ads.com
          @@||cdn.fairview-ads.com/js/clickTag.min.js
          @@||cdn.fairview-ads.com/js/creatives
          @@||s0.2mdn.net/ads/studio/Enabler.js
        `,
      },
    ],
  },
  fairAdblocker: {
    title: 'Fair AdBlocker',
    steps: [
      {
        text: 'Click ‘Fair Adblocker’ icon at the toolbar',
      },
      {
        text: 'Go to ‘Blocking Settings’ menu item',
        image: '/img/ad/fairadblocker-0.png',
      },
      {
        text: 'Inside ‘Blocking Settings’ switch ‘Advertisements’ to ‘Allow’',
        image: '/img/ad/fairadblocker-1.png',
      },
      {
        text: 'Go to any website and reload page to apply changes',
      },
    ],
  },
  adblocker: {
    title: 'Ad-Blocker',
    steps: [
      {
        text: 'Click to the AdBlocker icon on the toolbar',
      },
      {
        text: 'Go to Options page',
        image: '/img/ad/adblocker-0.png',
      },
      {
        text:
          'On the Ad-Blocker Options page - ‘Filter Lists’ tab and set the checkbox for EasyList filter to false (like on image below). And click the ‘Update now’ button to apply changes.',
        image: '/img/ad/adblocker-1.png',
      },
      {
        text: 'Go to ‘Add your own filters’ tab and add necessary filter 1 by 1 to the list',
        image: '/img/ad/adblocker-2.png',
      },
      {
        text: 'Go to ‘Whitelisted domains’ tab and add specific domains',
        image: '/img/ad/adblocker-3.png',
        snippet: `
          s0.2mdn.net
          fairview-ads.com
        `,
      },
      {
        text: 'Go to any website and reload page to see applied changes',
      },
    ],
  },
  adblock: {
    title: 'Ad-Blocker',
    steps: [
      {
        text: 'Click to AdBlock icon at the toolbar',
        image: '/img/ad/adblock-0.png',
      },
      {
        text: 'After opening the AdBlock’s Options page you should disable EasyList filter',
        image: '/img/ad/adblock-1.png',
      },
      {
        text: 'After that go to Customize tab in order to add necessary filters to list',
        image: '/img/ad/adblock-2.png',
        snippet: `
          @@||fairview-ads.com
          @@||cdn.fairview-ads.com/js/clickTag.min.js
          @@||cdn.fairview-ads.com/js/creatives
          @@||s0.2mdn.net/ads/studio/Enabler.js
        `,
      },
      {
        text:
          'Click the ‘Save’ button after adding filters. Reload the page where you have opened the sidebar and ads should appear there.',
      },
    ],
  },
  adsKiller: {
    title: 'Ads Killer Adblocker Plus',
    steps: [
      {
        text: 'Click to Ads Killer Adblocker Plus icon at the toolbar',
        image: '/img/ad/adskiller-0.png',
      },
      {
        text: 'After opening the AdBlock’s Options page you should disable EasyList filter',
        image: '/img/ad/adskiller-1.png',
      },
      {
        text: 'Click apply changes button',
      },
      {
        text: 'After that go to My Filters tab in order to add necessary filters to list',
        image: '/img/ad/adskiller-2.png',
        snippet: `
          @@||fairview-ads.com
          @@||cdn.fairview-ads.com/js/clickTag.min.js
          @@||cdn.fairview-ads.com/js/creatives
          @@||s0.2mdn.net/ads/studio/Enabler.js
        `,
      },
      {
        text: 'Go to any website and reload page to see applied changes',
      },
    ],
  },
};
